import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDownC({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 13.624V8a1 1 0 112 0v5.624l2.287-2.325a1 1 0 111.426 1.402l-3.998 4.066-.014.013a1 1 0 01-1.414-.011l-.002-.002L7.287 12.7A1 1 0 018.713 11.3L11 13.624zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
        fill={color}
      />
    </svg>
  )
}

export default SvgDownC
